module.exports = __webpack_public_path__ + "static/media/national-anthem.83a4e7ee.svg";